export interface Appointment {
  id: string;
  name: string;
  email: string;
  phone?: string;
  service_type: string;
  preferred_date?: string;
  preferred_time?: string;
  status: 'pending' | 'confirmed' | 'cancelled' | 'completed';
  notes?: string;
  admin_notes?: string;
  paid?: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface AppointmentType {
  id: string;
  name: string;
  description?: string;
  duration_minutes: number;
  color?: string;
  is_active: boolean;
  price?: number | string;
  category?: string;
  created_at?: string;
}

export interface AvailabilitySlot {
  id: string;
  day_of_week: number;
  start_time: string;
  end_time: string;
  is_active: boolean;
  max_bookings: number;
  created_at?: string;
}

export interface BlockedDate {
  id: string;
  date: string;
  reason?: string;
  created_at?: string;
}

export const appointmentTypesMock: AppointmentType[] = [
  {
    id: 'ac1',
    name: 'Consulta de diseño',
    description: 'Primera visita para conocer tu visión, tomar medidas y discutir opciones de diseño.',
    duration_minutes: 90,
    color: '#1a1a1a',
    is_active: true,
    price: 0,
    category: 'alta-costura',
  },
  {
    id: 'ac2',
    name: 'Prueba de patronaje',
    description: 'Revisión del patrón base y ajustes previos al tejido final.',
    duration_minutes: 60,
    color: '#4a4a4a',
    is_active: true,
    price: 0,
    category: 'alta-costura',
  },
  {
    id: 'ac3',
    name: 'Prueba en tejido final',
    description: 'Segunda prueba con el tejido definitivo para ajustes finos.',
    duration_minutes: 60,
    color: '#6b6b6b',
    is_active: true,
    price: 0,
    category: 'alta-costura',
  },
  {
    id: 'ac4',
    name: 'Entrega final',
    description: 'Última visita para la entrega final de la prenda terminada.',
    duration_minutes: 30,
    color: '#8a8a8a',
    is_active: true,
    price: 0,
    category: 'alta-costura',
  },
  {
    id: 'vn1',
    name: 'Consulta de novia',
    description: 'Primera cita para diseñar el vestido de novia de tus sueños.',
    duration_minutes: 90,
    color: '#d4a574',
    is_active: true,
    price: 0,
    category: 'vestidos-novia',
  },
  {
    id: 'vn2',
    name: 'Prueba de vestido de novia',
    description: 'Prueba intermedia para ver la evolución del vestido.',
    duration_minutes: 60,
    color: '#c9986a',
    is_active: true,
    price: 0,
    category: 'vestidos-novia',
  },
  {
    id: 'vn3',
    name: 'Prueba final de novia',
    description: 'Última prueba para asegurar que todo es perfecto.',
    duration_minutes: 45,
    color: '#b8865a',
    is_active: true,
    price: 0,
    category: 'vestidos-novia',
  },
  {
    id: 'vn4',
    name: 'Entrega vestido de novia',
    description: 'Entrega final del vestido listo para el gran día.',
    duration_minutes: 30,
    color: '#a6764e',
    is_active: true,
    price: 0,
    category: 'vestidos-novia',
  },
  {
    id: 'pa1',
    name: 'Consulta de arreglos',
    description: 'Evaluación de la prenda y presupuesto de arreglos.',
    duration_minutes: 30,
    color: '#4a7c59',
    is_active: true,
    price: 0,
    category: 'pret-a-porter',
  },
  {
    id: 'pa2',
    name: 'Prueba de arreglos',
    description: 'Prueba intermedia para verificar los ajustes realizados.',
    duration_minutes: 30,
    color: '#3d6b4a',
    is_active: true,
    price: 0,
    category: 'pret-a-porter',
  },
  {
    id: 'pa3',
    name: 'Ajustes express',
    description: 'Servicio rápido de ajustes menores para prendas existentes.',
    duration_minutes: 30,
    color: '#305a3b',
    is_active: true,
    price: 35,
    category: 'pret-a-porter',
  },
  {
    id: 'pa4',
    name: 'Recogida de prenda',
    description: 'Recogida de la prenda con los arreglos terminados.',
    duration_minutes: 15,
    color: '#23492c',
    is_active: true,
    price: 0,
    category: 'pret-a-porter',
  },
  {
    id: 'tm1',
    name: 'Consulta traje a medida',
    description: 'Primera cita para diseñar tu traje, smoking o chaqué a medida. Análisis de estilo, medidas y selección de tejidos.',
    duration_minutes: 60,
    color: '#2c3e50',
    is_active: true,
    price: 0,
    category: 'trajes-medida',
  },
  {
    id: 'tm2',
    name: 'Prueba de traje',
    description: 'Prueba intermedia para verificar el corte, caída y ajustes de la chaqueta y pantalón.',
    duration_minutes: 45,
    color: '#34495e',
    is_active: true,
    price: 0,
    category: 'trajes-medida',
  },
  {
    id: 'tm3',
    name: 'Prueba final traje',
    description: 'Última prueba para confirmar que el traje ajusta a la perfección antes de la entrega.',
    duration_minutes: 30,
    color: '#415b76',
    is_active: true,
    price: 0,
    category: 'trajes-medida',
  },
  {
    id: 'tm4',
    name: 'Entrega traje',
    description: 'Entrega final del traje terminado, incluyo instrucciones de cuidado y almacenamiento.',
    duration_minutes: 20,
    color: '#4d6a87',
    is_active: true,
    price: 0,
    category: 'trajes-medida',
  },
];

export const appointmentsMock: Appointment[] = [
  {
    id: 'a1',
    name: 'María González',
    email: 'maria@example.com',
    phone: '+34 612 345 678',
    service_type: 'Consulta inicial',
    preferred_date: '2026-05-15',
    preferred_time: '10:00',
    status: 'confirmed',
    notes: 'Vestido de gala para evento corporativo',
  },
  {
    id: 'a2',
    name: 'Laura Martínez',
    email: 'laura@example.com',
    phone: '+34 623 456 789',
    service_type: 'Prueba de vestido',
    preferred_date: '2026-05-18',
    preferred_time: '16:00',
    status: 'pending',
    notes: 'Segunda prueba del vestido de novia',
  },
  {
    id: 'a3',
    name: 'Carmen Ruiz',
    email: 'carmen@example.com',
    phone: '+34 634 567 890',
    service_type: 'Prueba final',
    preferred_date: '2026-05-20',
    preferred_time: '10:00',
    status: 'pending',
    notes: 'Entrega final vestido de cóctel',
  },
];

export const availabilitySlotsMock: AvailabilitySlot[] = [
  { id: 's1', day_of_week: 1, start_time: '10:00', end_time: '13:00', is_active: true, max_bookings: 1 },
  { id: 's2', day_of_week: 1, start_time: '16:00', end_time: '19:00', is_active: true, max_bookings: 1 },
  { id: 's3', day_of_week: 2, start_time: '10:00', end_time: '13:00', is_active: true, max_bookings: 1 },
  { id: 's4', day_of_week: 2, start_time: '16:00', end_time: '19:00', is_active: true, max_bookings: 1 },
  { id: 's5', day_of_week: 3, start_time: '10:00', end_time: '13:00', is_active: true, max_bookings: 1 },
  { id: 's6', day_of_week: 3, start_time: '16:00', end_time: '19:00', is_active: true, max_bookings: 1 },
  { id: 's7', day_of_week: 4, start_time: '10:00', end_time: '13:00', is_active: true, max_bookings: 1 },
  { id: 's8', day_of_week: 4, start_time: '16:00', end_time: '19:00', is_active: true, max_bookings: 1 },
  { id: 's9', day_of_week: 5, start_time: '10:00', end_time: '13:00', is_active: true, max_bookings: 1 },
  { id: 's10', day_of_week: 5, start_time: '16:00', end_time: '19:00', is_active: true, max_bookings: 1 },
];

export const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

export const statusLabels: Record<string, { label: string; color: string; bg: string; icon?: string }> = {
  pending: { label: 'Pendiente', color: 'text-amber-700', bg: 'bg-amber-50', icon: 'ri-time-line' },
  confirmed: { label: 'Confirmada', color: 'text-emerald-700', bg: 'bg-emerald-50', icon: 'ri-check-line' },
  cancelled: { label: 'Cancelada', color: 'text-red-700', bg: 'bg-red-50', icon: 'ri-close-line' },
  completed: { label: 'Completada', color: 'text-brand-black', bg: 'bg-brand-gray-200', icon: 'ri-check-double-line' },
};